import React from "react";
import { Component } from "react";
import { Button } from "react-bootstrap";
import { actions } from 'react-redux-form';
import store from "../../../store";


import { DATA_TYPE, ACTION_TYPES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, PLAN_COMPONENT_PROPNAME, INPUT_FIELD_TYPE } from "../../../constants/external-constants";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { CustomDropdown } from "../custom-form/custom-dropdown.component";
import { NotificationModal } from "../modal/notification-modal.component";
import Translation from "../../common/translation/translation.component";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import TableWithButton from "../details-table/table-with-button.component";
import { InputFieldFloatingLabel as InputField } from "../../common/custom-form/select-filter.component";
class AddPlanComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: "",
            viewDetailPage: false,
            titleBtn: false,
            enableAddBtn: false,
            enableEdit: false,
            keyIndex: null,
            selectedValue: '',
            activeDropdown: true,
            showDetails: false,
            modalMessage: "",
            showModal: false,
            dataTable: [],
            isExist: false,
            fieldChange: false,
            loading: true,
            tableLength: 0,
            showNotif: false,
            notifTitle: null,
            updatePlanComponentDetails: false,
            selectedItems: '',
            isError: false,
            hasError: {},
        }
    }

    handleCancel = () => {
        const { resetFinancePlanComponent } = this.props.planComponentAction;
        this.toggleActiveState();
        resetFinancePlanComponent();
        this.setState({
        })
    }

    componentDidMount() {
        const { getFinancePlanComponent } = this.props.planComponentAction;
        const { planDetailsId } = this.props;
        getFinancePlanComponent(planDetailsId);
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    }

    activateAddBtn() {
        if (this.state.glCode && this.state.costCenter && this.state.percent) {
            this.setState({ enableAddBtn: true });
        } else {
            this.setState({ enableAddBtn: false });
        }
    }

    HandleOnChange(e, field) {
        const { value } = e.target;
        if (value === '' || /^\d*(\.\d*)?$/.test(value)) {
            this.setState({ [field]: value }, () => {
                this.activateAddBtn();
            });
        }
    }

    ResetError = (value) => {
        this.setState({
            haveError: value
        })
    }

    handleGetFieldData(field, value) {
        const { FormChange } = this.props.planComponentAction;

        FormChange(`planComponentForm.${field}`, value[field])
    }

    handleInputChange(field, e) {
        const { FormChange } = this.props.planComponentAction;

        var value = e.target.value;

        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            FormChange(`planComponentForm.${field}`, value)
            this.setState(prevState => ({
                ...prevState,
                selectedItems: {
                    ...prevState.selectedItems,
                    [field]: value
                },
                fieldChange: true
            }));
        }
        FormChange(`planComponentForm.${field}`, value);
    };

    handleConfirmationModal = async (buttonType) => {
        const { updatePlanComponentDetails, keyIndex } = this.state;
        const { planComponentForm } = this.props;
        const { addPlanComponentDetails, updatePlanComponent } = this.props.planComponentAction;

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            if (updatePlanComponentDetails) {
                updatePlanComponent(keyIndex);
            } else {

                addPlanComponentDetails(planComponentForm);
            }

            this.setState(prev => ({
                showModal: !prev.showModal,
                enableEdit: false,
                updateCostAllocationDetails: false,
                isExist: false,
                isGreater: false
            }));
        }
        else {
            this.setState({
                showModal: false
            })
        }
    };

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }

    handleOpenNotif = (title) => {
        this.setState({
            showNotif: true,
            notifTitle: title
        });
    }

    setDefaultError = () => {
        this.setState({
            hasError: {}
        });
    }
    onClickAdd = () => { 
        const { planCatalogue, indexItem } = this.props;
        const { componentName, componentDetails, componentCost } = this.props.planComponentForm;

        if (planCatalogue.planComponents.dataTable[0].dataItem.length > 0) {
            const planComponentList = planCatalogue.planComponents.dataTable[0].dataItem.filter(
                (index) => index !== indexItem);

            var convertedComponentCost = parseInt(componentCost, 10);

            const isPlanComponentExist = planComponentList.some(
                item =>
                    item.ComponentName.toLowerCase() === componentName.toLowerCase() &&
                    item.ComponentDetails.toLowerCase() === componentDetails.toLowerCase() &&
                    item.ComponentCost === convertedComponentCost);

            if (planCatalogue.planComponents.dataTable[0].dataItem.length === 20) {
                this.setState({
                    haveError: true,
                    modalMessage: <Translation translationKey={"plan_components_limit_20"} />,
                    showNotif: true,
                    updatePlanComponentDetails: false,
                    keyIndex: indexItem
                });
                return;
            }
            else if (isPlanComponentExist) {
                this.setState({
                    haveError: true,
                    modalMessage: <Translation translationKey={"plan_component_already_exist"} />,
                    showNotif: true,
                    updatePlanComponentDetails: false,
                    keyIndex: indexItem
                });
                this.props.planComponentAction.setPlanComponentError();
                return;
            }
        }

        this.setState({
            showModal: true,
            updatePlanComponentDetails: false
        })

    }

    updatePlanComponent = async (indexItem) => {
        const { planComponents } = this.props.planCatalogue
        const { ComponentName, ComponentDetails, ComponentCost } = this.props.planComponentForm;

        const dataItem = planComponents.dataTable[0].dataItem;
         
      if (planComponents.dataTable[0].dataItem.length > 0) {
          const planComponentList = await dataItem.filter((item, index) => index !== indexItem);

            const isPlanComponentExist = planComponentList.some(
                item =>
                    item.ComponentName.toLowerCase() === ComponentName.toLowerCase() &&
                    item.ComponentDetails.toLowerCase() === ComponentDetails.toLowerCase() &&
                    item.ComponentCost.toString() === ComponentCost.toString()
          );

          const hasError = {
              IndexOne: !ComponentName,
              IndexTwo: !ComponentDetails,
              IndexThree: !ComponentCost
          }

          if (Object.values(hasError).some((error) => error)) {
              this.setState({
                  hasError,
                  isError: true,
                  modalMessage: <Translation translationKey={"populate_all_required_fields"} />,
                  showNotif: true,
              });
              return false;
          }
           else if (isPlanComponentExist) {
                this.setState({
                    haveError: true,
                    modalMessage: <Translation translationKey={"plan_component_already_exist"} />,
                    showNotif: true,
                    updatePlanComponentDetails: false,
                    keyIndex: indexItem
                });
                return;
             }
            else {
                this.setState({
                    showModal: true,
                    updatePlanComponentDetails: true,
                    keyIndex: indexItem,
                    updateCostAllocationDetails: false,
                });
            }
        }  
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    handelEnableEdit = (enable, index) => {
        this.setState({ enableEdit: enable, keyIndex: index })
    }

    onChangePlanComponent = (model, value) => {
        if (model === "planComponentForm.componentName") {
            store.dispatch(actions.change("planComponentForm.componentName", value))
        }
        else if (model === "planCatalogueDetailsForm.rateStatusId") {
            store.dispatch(actions.change("planComponentForm.componentName", value))
        }
        else if (model === "planCatalogueDetailsForm.componentCost") {
            store.dispatch(actions.change("planComponentForm.componentCost", value))
        }

        const formName = model.split(".")[0];
        store.dispatch(actions.resetErrors(formName));
    }

    render() {

        const { translator, planComponentForm } = this.props;
        const { dataTable } = this.props.planCatalogue.planComponents
        const { deletePlanComponent } = this.props.planComponentAction;
        const { componentName, componentDetails, componentCost } = this.props.planComponentForm;

        var enableAddButton = !componentName || !componentDetails || !componentCost;
        
        return (
            <>
                <CustomDropdown
                    label={<Translation translationKey={"add_plan_component"} />}
                    activeDropdown={this.state.activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                    <div className="add-sim-container add-cost-allocation-cont">
                        <div className="details-4-col-26-container capital-uppercase">
                            <NotificationModal
                                show={this.state.showNotif}
                                title={this.state.haveError ? 'Error' : 'Success'}
                                message={this.state.modalMessage ? this.state.modalMessage : `Plan Details ${this.state.notifTitle} successfully!`}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />

                            <InputField
                                className="form-control"
                                requiredField
                                type="text"
                                label={<Translation translationKey={"plan_component_name"} />}
                                value={componentName}
                                fieldProp='planComponentForm.componentName'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                                onChangeAction={this.onChangePlanComponent}
                            />

                            <InputField
                                className="form-control"
                                requiredField
                                type="text"
                                label={<Translation translationKey={"plan_component_details"} />}
                                value={componentDetails}
                                fieldProp='planComponentForm.componentDetails'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                                onChangeAction={this.onChangePlanComponent}
                            />

                            <InputField
                                className="form-control"
                                requiredField
                                type="text"
                                label={<Translation translationKey={"plan_component_cost"} />}
                                value={componentCost}
                                fieldProp='planComponentForm.componentCost'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                placeholder={translator("enter_text_placeholder")}
                                inputType={DATA_TYPE.decimal}
                                onChangeAction={this.onChangePlanComponent}
                            />

                            <div className="add-button-container custom-add-button">

                                <div className="btn-tooltiptext">
                                    {this.props.isReadAndWrite &&
                                        <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                    }
                                    <span className="tooltip-text">{<Translation translationKey="cancel_adding_plan_component" />}</span>
                                </div>

                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={this.state.updatePlanComponentDetails ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                                    title={this.state.updatePlanComponentDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />

                                    <div className={'btn-tooltiptext'}>
                                        {this.props.isReadAndWrite &&
                                            <Button
                                                disabled={enableAddButton}
                                                onClick={this.onClickAdd}
                                                variant="primary"
                                                className="btn-add"
                                            >
                                                {`${ACTION_TYPES.Add}`}

                                            </Button>
                                        }
                                        <span className="tooltip-text"><Translation translationKey="add_plan_component_details" /></span>
                                    </div>
                            </div>
                        </div>

                        <div className="details-table-container ">

                            <TableWithButton
                                datatable={dataTable}
                                haveDeleteBtn={(this.props.isReadAndWrite ? true : false)}
                                haveEditBtn={(this.props.isReadAndWrite ? true : false)}
                                deleteAction={deletePlanComponent}
                                updateAction={this.updatePlanComponent}
                                searchableDropdownData={[]}
                                inputField={PLAN_COMPONENT_PROPNAME}
                                optionsMap={[]}
                                selectedItems={planComponentForm}
                                selectedValue={this.state.selectedItems}
                                percentValue={this.props.percentValue}
                                handleSelectChange={() => { }}
                                handleInputChange={this.handleInputChange.bind(this)}
                                handleOpenNotif={this.handleOpenNotif}
                                handleGetFieldData={this.handleGetFieldData.bind(this)}
                                handelEnableEdit={this.handelEnableEdit}
                                handleCloseNotif={this.handleCloseNotif}
                                enableEdit={this.state.enableEdit}
                                keyIndex={this.state.keyIndex}
                                clearSelectedValue={this.clearSelectedValue}
                                hasError={this.state.hasError}
                                planComponentError={this.state.isError}
                                setDefaultError={this.setDefaultError}
                            />

                        </div>
                    </div>
                </CustomDropdown>
            </>
        );
    }
}


export default AddPlanComponent;


